import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import MerchantLayout from '../../layout/MerchantLayout';
import Scanner from '../../components/Scan/Scanner';

const useStyles = makeStyles({
  container: {
    display: 'grid',
    placeItems: 'center',
  },
});

const MerchantScanPage: React.FC = () => {
  const classes = useStyles();

  return (
    <MerchantLayout>
      <div className={classes.container}>
        <Scanner />
      </div>
    </MerchantLayout>
  );
};

export default MerchantScanPage;
